import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Menu } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import Image from '../../../../../../atoms/Image';
import InternalLink from '../../../../../../atoms/InternalLink';
import { ImagePropType, ObjectPropsPropType } from '../../../../../../services/proptypes';
import { classNames } from '../../../../../../utils/classname';
import useSemanticUiProps from '../../../../../foundation/hooks/use-semantic-ui-props/use-semantic-ui-props';
import './Logo.css';
var defaultProps = {
  title: '',
  src: '',
  imageProps: {},
  menuItemProps: {}
};
export default function Logo(_ref) {
  var title = _ref.title,
    src = _ref.src,
    imageProps = _ref.imageProps,
    menuItemProps = _ref.menuItemProps;
  var _useSemanticUiProps = useSemanticUiProps(),
    getMenuItemProps = _useSemanticUiProps.getMenuItemProps;
  if (_isEmpty(title) && _isEmpty(src)) {
    return null;
  }
  var content = _isEmpty(src) ? title : /*#__PURE__*/React.createElement(Image, _extends({
    altText: "Logo",
    src: src,
    className: "image"
  }, imageProps));
  return /*#__PURE__*/React.createElement(Menu.Item, _extends({
    className: classNames({
      logo: true,
      image: !_isEmpty(src)
    }),
    header: true
  }, getMenuItemProps(menuItemProps)), /*#__PURE__*/React.createElement(InternalLink, {
    to: "/"
  }, content));
}
Logo.defaultProps = defaultProps;